module.exports = __webpack_public_path__ + "fonts/ObjectSans-Regular.5b82442d.otf";